module.exports = __webpack_public_path__ + "static/media/background-estate.af6ec917.svg";